
import { Inject, Injectable } from '@angular/core';
import { ApiCommonService } from 'cbc-shared-lib';
import { Observable, throwError } from 'rxjs';
import { catchError, map, timeout } from 'rxjs/operators';
import { Sgke402aRequest, Sgke402aResponse, Sgke402aService } from 'sg-api';
import { FeaturesLibConfig } from '../../../../../config/features-lib-config';
import { FEATURES_LIB_CONFIG } from '../../../../../config/features-lib-config.token';

@Injectable({
  providedIn: 'root'
})
export class UsedSgke402aService {

  /**
   * コンストラクタ
   * @param {Sgke402aService} service
   * @param {ApiCommonService} apiCommonService
   * @param {FeaturesLibConfig} featuresLibConfig
   * @memberof UsedSgke402aService
   */
  constructor(
    public service: Sgke402aService,
    public apiCommonService: ApiCommonService,
    @Inject(FEATURES_LIB_CONFIG) private featuresLibConfig: FeaturesLibConfig
  ) { }

  /**
   * SGKE402A_欠損承認依頼・最終承認検索API呼び出し
   * @param {Sgke402aRequest} request 
   * @returns {Observable<Sgke402aResponse>}
   * @memberof UsedSgke402aService
   */
  public doSgke402a(request: Sgke402aRequest): Observable<Sgke402aResponse> {
    return this.service.sgke402aPost(this.apiCommonService.setRequestCommon(<any>request), 'response')
      .pipe(
        map(
          response => {
            // エラーが設定されていないかチェックし、エラーの場合catchError()に処理が移る
            this.apiCommonService.checkError(response);
            return response.body;
          }),
        timeout(Number(this.featuresLibConfig.httpTimeout)),
        catchError((err) => {
          this.apiCommonService.dispErrorMessage(err, 'bill', 'SGKE402A');
          return throwError(err.message);
        })
      );
  }

}
